function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fe6848",
  d: "M7 0C3.134 0 0 3.135 0 7c0 3.867 3.134 7 7 7s7-3.133 7-7c0-3.865-3.134-7-7-7zm0 3.105c.655 0 1.185.53 1.185 1.185S7.655 5.476 7 5.476s-1.185-.53-1.185-1.186c0-.654.53-1.185 1.185-1.185zm1.58 7.17c0 .186-.151.338-.338.338H5.758c-.187 0-.339-.152-.339-.339v-.677c0-.187.152-.339.34-.339h.338V7.452h-.339c-.187 0-.339-.152-.339-.34v-.677c0-.187.152-.338.34-.338h1.806c.187 0 .338.151.338.338v2.823h.339c.187 0 .339.152.339.339v.677z"
});

var SvgInfoError = function SvgInfoError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfoError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/InfoError.7c353b58.svg";
export { ForwardRef as ReactComponent };